import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import Hero from "src/components/Hero/Hero";
import { useHubCardLivePreview } from "src/hooks/useHubCardLivePreview";
import { mapEgdCarouselSlide } from "src/utils/mapEgdCarousel";
import { egdCarouselLivePreviewRequestHandler } from "src/utils/egdCarouselLivePreviewHandler";

/**
 * Payload Live Preview iframe target for `egd-carousel`.
 * Renders one Hero slide (not the full carousel) for CMS editors.
 * Always available — independent of REACT_APP_PAYLOAD_SOURCES.
 */
const EgdCarouselSlidePreview = () => {
  const { t, i18n } = useTranslation();
  const { card, isLoading } = useHubCardLivePreview(
    "carousels",
    {
      depth: 0,
      mapDoc: mapEgdCarouselSlide,
      requestHandler: egdCarouselLivePreviewRequestHandler,
      forceEnabled: true,
    },
    i18n.language
  );

  return (
    <PreviewPage>
      {isLoading ? (
        <div className="preview-status">
          <Spinner animation="border" variant="light" role="status">
            <span className="visually-hidden">{t("loading")}</span>
          </Spinner>
        </div>
      ) : !card ? (
        <div className="preview-status">
          <p>{t("egd.carouselPreview.waitingForDocument")}</p>
        </div>
      ) : (
        <Hero
          image={card.image}
          imageAlt={card.image_alt || card.title}
          bgImage={card.bg_image}
          title={card.title}
          titleAs="span"
          description={card.description}
          buttonSettings={{
            label: `${card.button_text || t("button.check-it-out")}`,
            href: `${card.button_link || "#"}`,
            size: "large",
            width: "wide",
            color: "black",
            bgColor: "white",
            specialHover: card.button_disabled === "true" ? false : true,
            disabled: card.button_disabled === "true",
          }}
          descriptionBgColor={card.description_bg_color || "#0000006d"}
        />
      )}
    </PreviewPage>
  );
};

const PreviewPage = styled.div`
  min-height: 100vh;
  background: var(--black);
  color: var(--white);
  box-sizing: border-box;

  .preview-status {
    width: 100%;
    text-align: center;
    color: var(--mutedwhite);
    padding: 3rem 1rem;
  }
`;

export default EgdCarouselSlidePreview;
